module.exports = __webpack_public_path__ + "static/media/land-scanner-banner-img-mobile.340a189c.jpg";